import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.scss'],
    standalone: false
})
export class ActionsComponent {
  @Input() formGroup: FormGroup;
  @Input() entity: string;
  @Input() isDocusignEnabled: boolean;

  get actionsFormArray(): FormArray<FormGroup> {
    return this.formGroup.get('actions') as FormArray<FormGroup>;
  }

  prettyPrintJSONForHTML(json: unknown, space: number = 2): string {
    try {
      const jsonString = JSON.stringify(json, null, space);
      return '<pre>' + jsonString.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;') + '<pre>';
    } catch (error) {
      console.error('Invalid JSON provided', error);
      return 'Invalid JSON';
    }
  }
}
